import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { EmptyRecEffFilter, Filter } from "./Filter";
import { SubTable } from "./SubTable";
import { SkillSubTableReport } from "./SkillSubTable";
import { SubTableEfficiencyReport } from "./SubTabServedReport";

interface IBranchLatency {
    branchName?: string,
    company_name?: string
    req?: number
    sub?: number
    sub45?: number
    sub46?: number
    sub90?: number
    sub120?: number
    serv?: number,
    serve?: number,
    serve45?: number,
    serve46?: number,
    serve90?: number,
    serve120?: number,
}

export const BranchLatency = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBranchLatency>, loading: boolean });
    const [tFooter, setTFooter] = useState<IBranchLatency>({});
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);
    const [salEffFilter, setSalEffFilter] = useState<any>(EmptyRecEffFilter);
    const [tableLoad, setTableLoad] = useState(false);

    const [filter, setFilter] = useState(false);
    const hideFilterDialog = () => {
        setFilter(false);
    };

    const [subTable, setSubTable] = useState({ open: false, resType: 0, catID: 0, branchID: 0, totalRec: null } as { open: boolean, resType: number, catID?: number, branchID?: number, totalRec?: boolean | null });
    const [subTable1, setSubTable1] = useState({ open: false, resType: 0, branchID: 0, totalRec: null } as { open: boolean, resType: number, branchID?: number, totalRec?: boolean | null });
    const [skillSubTable, setSkillSubTable] = useState({ open: false, resType: 0, branchID: 0, totalRec: null } as { open: boolean, resType: number, branchID?: number, totalRec?: boolean | null });

    const hideSubTableDialog = () => {
        setSubTable({ open: false, resType: 0, catID: 0, branchID: 0, totalRec: null });
        setSubTable1({ open: false, resType: 0, branchID: 0, totalRec: null });
        setSkillSubTable({ open: false, resType: 0, branchID: 0, totalRec: null });;

    };

    useEffect(() => {
        if (tableLoad) {
        loadTableData();
        setTableLoad(false);
        }
    }, [tableLoad]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("BranchLatencyReport", "GET", null, `filter=${JSON.stringify(salEffFilter)}`, toast);
        if (response) {
            const data: Array<IBranchLatency> = await response.json();

            const _data: Array<IBranchLatency> = [];
            let totalNoOfSub = 0;
            let totalNoOfsub45 = 0;
            let totalNosub46 = 0;
            let totalNosub90 = 0;
            let totalNoOfsub120 = 0;
            let totalNoOfserv = 0;
            let totalNoOfAllReq = 0;


            data.forEach((d, i) => {
                if (d.req) totalNoOfAllReq += d.req;
                if (d.sub) totalNoOfSub += d.sub;
                if (d.sub45) totalNoOfsub45 += d.sub45;
                if (d.sub46) totalNosub46 += d.sub46;
                if (d.sub90) totalNosub90 += d.sub90;
                if (d.sub120) totalNoOfsub120 += d.sub120;
                if (d.serv) totalNoOfserv += d.serv;

                _data.push(d);
            });
            const totalRecords: IBranchLatency = {
                company_name: "Total Records",
                sub: totalNoOfSub,
                sub46: totalNosub46,
                sub90: totalNosub90,
                sub120: totalNoOfsub120,
                serv: totalNoOfserv,
                sub45: totalNoOfsub45
            };
            setTFooter(totalRecords);

            setTableData({ tableData: _data, loading: false });
        }
    }

    const rightToolbarTemplate = () => {
        const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        return (
            permissions.is_Export || loginObj.is_Team_Lead ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Branch Latency Report</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const allReq = (rowData: any) => <span onClick={() => setSkillSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 8 })} className="cursor-pointer text-cyan-700 underline">{rowData.req}</span>
    const noOfSub = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 1 })} className="cursor-pointer text-cyan-700 underline">{rowData.sub}</span>
    const noOfServe = (rowData: any) => <span onClick={() => setSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 10, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.serv}</span>
    // const noOfServe = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 11 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve}</span>;
    // const noOfServe = (rowData: any) => <span onClick={() => setSkillSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 5 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve}</span>;
    const noOfSub45 = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 2 })} className="cursor-pointer text-cyan-700 underline">{rowData.sub45}</span>
    // const noOfServe45 = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 22 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve45}</span>;
    const noOfServe45 = (rowData: any) => <span onClick={() => setSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 6, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve45}</span>;
    const noOfSub46 = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 3 })} className="cursor-pointer text-cyan-700 underline">{rowData.sub46}</span>
    // const noOfServe46 = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 33 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve46}</span>;
    const noOfServe46 = (rowData: any) => <span onClick={() => setSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 7, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve46}</span>;
    const noOfSub90 = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 4 })} className="cursor-pointer text-cyan-700 underline">{rowData.sub90}</span>
    // const noOfServe90 = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 44 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve90}</span>;
    const noOfServe90 = (rowData: any) => <span onClick={() => setSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 8, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve90}</span>;
    const noOfSub120 = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 5 })} className="cursor-pointer text-cyan-700 underline">{rowData.sub120}</span>
    // const noOfServe120 = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 55 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve120}</span>;
    const noOfServe120 = (rowData: any) => <span onClick={() => setSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 9, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.serve120}</span>;

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter salEffFilter={salEffFilter} setSalEffFilter={setSalEffFilter} excelLoading={excelLoading} onSearch={() => setTableLoad(true)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={tFooter.company_name} />
                <Column field="company_name" header="Company" sortable />
                <Column field="branchName" header="Branch" sortable />
                <Column field="req" header="#Req" sortable body={allReq}
                    footer={() => {
                        const noOfreq = tableData.tableData.reduce((sum, item) => sum + (item.req || 0), 0);
                        return <span
                            // onClick={() => setSubTable({ open: true, resType: 1, totalRec: true })}
                            className="">{noOfreq}</span>;
                    }}
                />
                <Column field="serve" header="#Serve" sortable body={noOfServe}
                    footer={() => {
                        const noOfServe = tableData.tableData.reduce((sum, item) => sum + (item.serv || 0), 0);
                        return <span className="">{noOfServe}</span>;
                    }}
                />
                <Column field="sub" header="#Sub" sortable body={noOfSub}
                    footer={() => {
                        const noOfSub = tableData.tableData.reduce((sum, item) => sum + (item.sub || 0), 0);
                        return <span
                            //onClick={() => setSubTable1({ open: true, resType: 1, totalRec: true })}
                            className="">{noOfSub}</span>;
                    }}
                />

                <Column field="sub45" header="#Sub 0-45" body={noOfSub45} sortable footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.sub45 || 0), 0);
                    return <span className="">{AllReq}</span>;
                }} />
                <Column field="serve45" header="#Served 0-45" body={noOfServe45} sortable footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.serve45 || 0), 0);
                    return <span
                        // onClick={() => setSubTable({ open: true, resType: 1 })}
                        className="">{AllReq}</span>;
                }} />

                <Column field="sub46" header="#Sub 46-90" sortable body={noOfSub46} footer={() => {
                    const No_Serve = tableData.tableData.reduce((sum, item) => sum + (item.sub46 || 0), 0);
                    return <span
                        //  onClick={() => setSubTable({ open: true, resType: 5 })}
                        className="">{No_Serve}</span>;
                }} />
                <Column field="serve46" header="#Served 46-90" sortable body={noOfServe46} footer={() => {
                    const No_Serve = tableData.tableData.reduce((sum, item) => sum + (item.serve46 || 0), 0);
                    return <span className="">{No_Serve}</span>;
                }} />

                <Column field="sub90" header="#Sub 91-120" sortable body={noOfSub90} footer={() => {
                    const UnServe = tableData.tableData.reduce((sum, item) => sum + (item.sub90 || 0), 0);
                    return <span
                        // onClick={() => setSubTable({ open: true, resType: 6, totalRec: true })}
                        className="">{UnServe}</span>;
                }} />
                <Column field="serve90" header="#Served 91-120" sortable body={noOfServe90} footer={() => {
                    const UnServe = tableData.tableData.reduce((sum, item) => sum + (item.serve90 || 0), 0);
                    return <span className="">{UnServe}</span>;
                }} />

                <Column field="sub120" header="#Sub 120+" body={noOfSub120} sortable
                    footer={() => {
                        const noOfSub = tableData.tableData.reduce((sum, item) => sum + (item.sub120 || 0), 0);
                        return <span
                            // onClick={() => setSubTable1({ open: true, resType: 1, totalRec: true })}
                            className="">{noOfSub}</span>;
                    }}
                />
                <Column field="serve120" header="#Served 120+" body={noOfServe120} sortable
                    footer={() => {
                        const noOfSub = tableData.tableData.reduce((sum, item) => sum + (item.serve120 || 0), 0);
                        return <span
                            // onClick={() => setSubTable1({ open: true, resType: 1, totalRec: true })}
                            className="">{noOfSub}</span>;
                    }}
                />


            </DataTable>
            <SubTable open={subTable1.open} branchID={subTable1.branchID} resType={subTable1.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salEffFilter} totalRec={subTable1.totalRec} recType={'branchWise'} />
            <SkillSubTableReport open={skillSubTable.open} branchID={skillSubTable.branchID} resType={skillSubTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salEffFilter} recType={'branchWise'} totalRec={skillSubTable.totalRec} />

            <SubTableEfficiencyReport open={subTable.open} catID={subTable.catID} branchID={subTable.branchID} resType={subTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salEffFilter} recType={'branchWise'} totalRec={subTable.totalRec} />
            {/* {/ <Filter open={filter} hideDialog={hideFilterDialog} setSalEffFilter={setSalEffFilter} toast={toast} /> /} */}
            <Toast ref={toast} />
        </>
    );
}
